
import React from 'react'
import ApiDoc from '../../apidoc'
import api from '../../../../../../consent-server/dist/openapi/v0/openapi.json';

export default props => <ApiDoc spec={api} {...props} />
